/* tslint:disable */
/* eslint-disable */
/**
 * LPPSWebApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { formatDateOnly, mapValues } from '../runtime';
import type { ActionType } from './ActionType';
import {
    ActionTypeFromJSON,
    ActionTypeFromJSONTyped,
    ActionTypeToJSON,
    ActionTypeToJSONTyped,
} from './ActionType';
import type { CreatePriceRowDto } from './CreatePriceRowDto';
import {
    CreatePriceRowDtoFromJSON,
    CreatePriceRowDtoFromJSONTyped,
    CreatePriceRowDtoToJSON,
    CreatePriceRowDtoToJSONTyped,
} from './CreatePriceRowDto';
import type { CreatePriceMode } from './CreatePriceMode';
import {
    CreatePriceModeFromJSON,
    CreatePriceModeFromJSONTyped,
    CreatePriceModeToJSON,
    CreatePriceModeToJSONTyped,
} from './CreatePriceMode';

/**
 * 
 * @export
 * @interface SaveCreatePriceRequest
 */
export interface SaveCreatePriceRequest {
    /**
     * 
     * @type {ActionType}
     * @memberof SaveCreatePriceRequest
     */
    actionType: ActionType;
    /**
     * 
     * @type {CreatePriceMode}
     * @memberof SaveCreatePriceRequest
     */
    mode: CreatePriceMode;
    /**
     * 
     * @type {Date}
     * @memberof SaveCreatePriceRequest
     */
    validFromDate: Date;
    /**
     * 
     * @type {Array<CreatePriceRowDto>}
     * @memberof SaveCreatePriceRequest
     */
    priceRows: Array<CreatePriceRowDto>;
}



/**
 * Check if a given object implements the SaveCreatePriceRequest interface.
 */
export function instanceOfSaveCreatePriceRequest(value: object): value is SaveCreatePriceRequest {
    if (!('actionType' in value) || value['actionType'] === undefined) return false;
    if (!('mode' in value) || value['mode'] === undefined) return false;
    if (!('validFromDate' in value) || value['validFromDate'] === undefined) return false;
    if (!('priceRows' in value) || value['priceRows'] === undefined) return false;
    return true;
}

export function SaveCreatePriceRequestFromJSON(json: any): SaveCreatePriceRequest {
    return SaveCreatePriceRequestFromJSONTyped(json, false);
}

export function SaveCreatePriceRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): SaveCreatePriceRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'actionType': ActionTypeFromJSON(json['actionType']),
        'mode': CreatePriceModeFromJSON(json['mode']),
        'validFromDate': (new Date(json['validFromDate'])),
        'priceRows': ((json['priceRows'] as Array<any>).map(CreatePriceRowDtoFromJSON)),
    };
}

export function SaveCreatePriceRequestToJSON(json: any): SaveCreatePriceRequest {
    return SaveCreatePriceRequestToJSONTyped(json, false);
}

export function SaveCreatePriceRequestToJSONTyped(value?: SaveCreatePriceRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'actionType': ActionTypeToJSON(value['actionType']),
        'mode': CreatePriceModeToJSON(value['mode']),
        'validFromDate': (formatDateOnly(value['validFromDate'])),
        'priceRows': ((value['priceRows'] as Array<any>).map(CreatePriceRowDtoToJSON)),
    };
}

